import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import Table from '../../Common/table';
import swal from 'sweetalert';
import axios from 'axios';
import dateTime from '../../utill/dateTime';
import api from '../../config.json'
import Loading from '../../utill/LoadingComponent';
import _ from 'lodash';

const ComponentCodeList = ({ history ,RightName,getRightsForAccess,Heading}) => {
    const [list, setList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [sortColumn,setSortColumn]=useState({path:'FieldName',order:'asc'})
console.log(list,"fdskhfbsdj")
    useEffect(() => {
        Heading('Compound Code Master')
        handleGetData()
    }, [])
    const handleSort = sortColumn => {
        if (list.length > 0) {
          const sorted = _.orderBy(list, [sortColumn.path], [sortColumn.order]);
          // setState({ sortColumn, componentList: sorted });
          setList(sorted)
        }
      }
    const handleGetData = () => {
        setLoader(true)
        axios.get(api.api + 'compoundMaster')
            .then((result) => {
                // consol(result.data)
                setLoader(false)
                setList(result.data);
            })
            .catch((err) => {
                swal(`${err}`)
                setLoader(false)
            })
    }

    const onDelete = (data) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this",
            icon: "warning",
            buttons: true,
            dangerMode: true
        }).then(willDelete => {
            if (willDelete) {
                // this.setState({ querySuccess: true });
                axios
                    .delete(api.api + "compoundMaster/" + data._id, { data: data })
                    .then(result => {
                        // consol(result.data)
                        if (result.data.ok === 1 && result.data.deletedCount === 1) {
                            let filterData = list.filter(
                                obj => obj._id !== data._id
                            );
                            swal('deleted Suceesfully')
                            setList(filterData)
                            setLoader(false)
                        }
                    })
                    .catch(err => {
                        setLoader(false)
                        swal(`${err.response.data.message}`);
                    });
            } else {
                setLoader(false)
                // swal("Your imaginary file is safe!");
            }
        });
    }


    const columns = [
        { path: 'Name', label: 'Name' },
        { path: 'CompoundCode', label: 'Compound Code' },
        { path: 'createdAt', label: 'Created Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.createdAt)}</label><br /></React.Fragment> },
        { path: 'updatedAt', label: 'Last Updated Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label><br /></React.Fragment> },
        { path: 'update', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => history.push("/setting/component_code/form", { action: "update", data: user })} className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faEdit} /></button> },
        // { path: 'view', content: user => <button onClick={() => this.props.onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
        { path: 'delete', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }

    ]

    return (<>
        <div className='text-center'>
            {loader?<Loading/>:""}
            {/* <p>Configure Checkpoint List</p> */}
        </div>
       {getRightsForAccess('StaticDataRights', RightName, "write") &&  <a onClick={() => history.push('/setting/component_code/form', { action: "add", data: {} })} style={{ cursor: 'pointer' }} className='btn btn-sm btn-primary ml-2 mt-2 common-anchor'

        >
            <FontAwesomeIcon size='1x' icon={faPlus} /> Create Compound Code </a>}
        {/* <a
          style={{ cursor: "pointer", color: 'white' }}
          className="float-left btn btn-sm btn-primary "
          //onClick={this.handleUploadGuagesDoc}
        >
          {" "}

          <FontAwesomeIcon size="1x" icon={faFileImport} /> Import Excel
        </a> */}
        {list.length < 0 ? "Data Not Available" : <Table sortColumn={sortColumn} onSort={handleSort} columns={columns} data={list} />}

    </>);
}

export default ComponentCodeList;